import api from "utils/api";

export const getCommunicationSettings = async () => {
  try {
    const response = await api.get("/communication-settings");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateCommunicationSettings = async (data) => {
  try {
    const response = await api.patch("/communication-settings", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
